<!-- IE warning -->
<p *isIE class="ie-warning">
    <strong><i class="far fa-exclamation-triangle"></i> You are currently using an outdated version of Internet Explorer.</strong><br>
    For the best experience, please visit this site on a modern browser like Chrome, Firefox or Safari.
</p>

<div class="d-flex flex-column min-vh-100">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white site-navbar" [class.scrolled]="navbarScrolled" *ngIf="!hasRoute('maintenance')">
        <div class="container">
            <a class="navbar-brand" [routerLink]="['/']">
                <img src="/assets/images/cvd_prevent_mark.svg" height="36" alt="CVDPREVENT mark">
            </a>
            <button type="button" class="navbar-toggler" (click)="toggleMenu()"
                [attr.aria-expanded]="menuOpen" aria-haspopup="dialog" aria-label="Menu">
                <i [class]="menuOpen ? 'far fa-times' : 'far fa-bars'" aria-hidden="true"></i>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item ms-3" [routerLinkActive]="['active']">
                        <a class="nav-link" [routerLink]="['/insights']">Insights</a>
                    </li>
                    <!-- Driven from the router rather than routerLinkActive: the section
                         covers /outcomes-intro and /outcomes, not just the link's own URL. -->
                    <li class="nav-item" [class.active]="outcomesActive">
                        <a class="nav-link" [routerLink]="['/outcomes-intro']">Outcomes</a>
                    </li>
                    <li class="nav-item" [routerLinkActive]="['active']">
                        <a class="nav-link" [routerLink]="['/data-extract']">Extracts</a>
                    </li>
                    <li class="nav-item" [routerLinkActive]="['active']">
                        <a class="nav-link" [routerLink]="['/api']">API</a>
                    </li>
                    <li class="nav-item" ngbDropdown #drop="ngbDropdown" display="dynamic" placement="bottom-end" (mouseenter)='over(drop)' (mouseleave)='out(drop)'>
                        <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarDropdown1" role="button">
                            The Audit <i class="fas fa-caret-down ms-1"></i>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="navbarDropdown1" class="dropdown-menu">
                            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/about']">About</a>
                            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/methodology']">Methodology</a>
                            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/quality-improvement-overview']">Quality Improvement</a>
                            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/resources']">Resources</a>
                            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/outputs']">Outputs</a>
                        </div>
                    </li>
                    <li class="nav-item" [routerLinkActive]="['active']">
                        <a class="nav-link" [routerLink]="['/events']">Events</a>
                    </li>
                    <li class="nav-item" [routerLinkActive]="['active']">
                        <a class="nav-link" [routerLink]="['/news']">News</a>
                    </li>
                </ul>
                <!-- <ul class="navbar-nav ms-auto"></ul> -->
            </div>
        </div>
    </nav>

    <!-- Content -->
    <main class="flex-grow-1">
        <router-outlet></router-outlet>
    </main>

    <!-- Footer -->
    <footer *ngIf="!hasRoute('maintenance')">
        <div class="container">
            <div class="footer-top">
                <div class="footer-logos">
                    <img src="/assets/images/agem.jpg" alt="The Office for Health Improvement and Disparities logo" width="463" height="175" loading="lazy" decoding="async">
                    <img src="/assets/images/logo_nhsbn.png" alt="The NHS Benchmarking Network logo" width="745" height="183" loading="lazy" decoding="async">
                </div>
                <div class="footer-links d-print-none">
                    <button type="button" class="footer-link" (click)="linkToFeedbackForm()">
                        <i class="fal fa-comment me-2" aria-hidden="true"></i>Feedback
                    </button>
                    <button type="button" class="footer-link" (click)="privacyDataCollection()">
                        <i class="far fa-cookie me-2" aria-hidden="true"></i>Privacy Policy
                    </button>
                </div>
            </div>
            <p class="footer-legal">
                Cardiovascular Disease Prevention Audit (CVDPREVENT). Produced by Arden &amp; GEM Commissioning Support Unit and the NHS Benchmarking Network.<br />
                &copy; Copyright NHS England 2021 - {{currentYear}}. All rights reserved.
            </p>
        </div>
    </footer>

</div>

<!-- Quick links to the tools, at the foot of the viewport on phones and tablets.
     Hidden on the pages where the period and area selector takes that slot. -->
<app-mobile-nav *ngIf="!hasRoute('maintenance')"></app-mobile-nav>

<!-- The menu behind the hamburger, below the navbar's collapse point -->
<ng-template #siteMenu>
    <div class="cvdp-drawer__header">
        <img src="/assets/images/cvd_prevent_mark.svg" height="32" alt="CVDPREVENT">
        <h2 class="cvdp-drawer__title visually-hidden" id="cvdpMenuTitle">Menu</h2>
        <button type="button" class="cvdp-drawer__close" (click)="closeMenu()" aria-label="Close menu">
            <i class="far fa-times" aria-hidden="true"></i>
        </button>
    </div>

    <nav class="cvdp-drawer__body" aria-labelledby="cvdpMenuTitle">
        <p class="cvdp-drawer__heading">Tools</p>
        <a class="cvdp-drawer__link" [routerLink]="['/insights']" routerLinkActive="cvdp-drawer__link--active"
            (click)="closeMenu()">Insights</a>
        <a class="cvdp-drawer__link" [routerLink]="['/outcomes-intro']"
            [class.cvdp-drawer__link--active]="outcomesActive"
            (click)="closeMenu()">Outcomes</a>
        <a class="cvdp-drawer__link" [routerLink]="['/data-extract']" routerLinkActive="cvdp-drawer__link--active"
            (click)="closeMenu()">Extracts</a>

        <p class="cvdp-drawer__heading">The audit</p>
        <button type="button" class="cvdp-drawer__link cvdp-drawer__link--toggle"
            [attr.aria-expanded]="auditExpanded" aria-controls="cvdpMenuAudit"
            (click)="auditExpanded = !auditExpanded">
            About the audit
            <i class="fas cvdp-drawer__caret" [class.fa-chevron-down]="!auditExpanded"
                [class.fa-chevron-up]="auditExpanded" aria-hidden="true"></i>
        </button>
        <div class="cvdp-drawer__sub" id="cvdpMenuAudit" *ngIf="auditExpanded">
            <a class="cvdp-drawer__sublink" [routerLink]="['/about']" routerLinkActive="cvdp-drawer__link--active"
                (click)="closeMenu()">About</a>
            <a class="cvdp-drawer__sublink" [routerLink]="['/methodology']" routerLinkActive="cvdp-drawer__link--active"
                (click)="closeMenu()">Methodology</a>
            <a class="cvdp-drawer__sublink" [routerLink]="['/quality-improvement-overview']" routerLinkActive="cvdp-drawer__link--active"
                (click)="closeMenu()">Quality Improvement</a>
            <a class="cvdp-drawer__sublink" [routerLink]="['/resources']" routerLinkActive="cvdp-drawer__link--active"
                (click)="closeMenu()">Resources</a>
            <a class="cvdp-drawer__sublink" [routerLink]="['/outputs']" routerLinkActive="cvdp-drawer__link--active"
                (click)="closeMenu()">Outputs</a>
        </div>

        <p class="cvdp-drawer__heading">More</p>
        <a class="cvdp-drawer__link" [routerLink]="['/events']" routerLinkActive="cvdp-drawer__link--active"
            (click)="closeMenu()">Events</a>
        <a class="cvdp-drawer__link" [routerLink]="['/news']" routerLinkActive="cvdp-drawer__link--active"
            (click)="closeMenu()">News</a>
        <a class="cvdp-drawer__link" [routerLink]="['/api']" routerLinkActive="cvdp-drawer__link--active"
            (click)="closeMenu()">API documentation</a>
    </nav>
</ng-template>

<!-- Cookies Banner  -->
<div *ngIf="cookieBannerVisible && !hasRoute('maintenance')" class="cookies-banner">
    <p class="small mb-3">
        This website uses cookies to provide you with a great user experience.
        <a (click)="privacyDataCollection()">Read our privacy policy here</a>.
    </p>
    <div class="d-flex">
        <button class="btn btn-sm btn-success text-white me-2 flex-fill" type="button" (click)="allowCookies()">Agree</button>
        <button class="btn btn-sm btn-outline-secondary flex-fill" type="button" (click)="dismissCookies()">Dismiss</button>
    </div>
</div>

<!-- User Survey: the logic behind this is commented out in app.component.ts
     (setUserSurvey does not exist and userSurveyVisible is never set), so the
     card can never appear. Kept here, disabled, until the feature is decided on.
<!- - User Survey - ->
<ng-container *ngIf="userSurveyVisible">
    <div class="card text-white bg-dark shadow-lg border-light" id="userSurvey">
        <div class="card-body">
            <h5 class="card-title">
                <i class="fas fa-comments me-2"></i>How did you hear about us?
            </h5>
            <p class="card-text">
                Thank you for your interest in CVDPREVENT. We want to hear from you!   
            </p>
            <p class="card-text">
                Could you spare 1 minute to answer our short five question survey to help improve the experience of other CVDPREVENT users?
            </p>
            <button (click)="setUserSurvey()" class="btn btn-light">Open Survey</button>
                        <button type="button" class="btn btn-outline-info ms-2" (click)="userSurveyVisible = false">Close</button>
        </div>
      </div>
</ng-container>
-->